import { useQuery } from "@tanstack/react-query";

import { getCalendars } from "api/generated/calendars/calendars";
import { CalendarView } from "api/generated/model";

export const CALENDAR_LIST_QUERY_KEY = "calendars";

export const useCalendarListQuery = (placeholderData: CalendarView[]) =>
    useQuery({
        queryKey: [CALENDAR_LIST_QUERY_KEY],
        queryFn: async () => {
            const response = await getCalendars();
            return response.data.content.map(
                (dtoContent) => dtoContent.resource
            );
        },
        placeholderData,
        retry: true,
    });
